<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            Instructions: Section 135 — Local Use Of Funds
        </ModuleTitleNav>

        <h5 class="text-danger">
            (Required For Portal And State Approval)
        </h5>
        <p class="info-text">
            Perkins recipients are required to provide certain services as a condition of receiving funding.
            The Local Application must identify how the college is meeting these requirements.
            The requirements can be met with either Perkins or institutional funds but a description
            of how they will be met is required regardless of funding.
        </p>
        <p>
            <em>
                There may be some duplication in Sections 134 and 135 but information is needed
                individually for each section to assure compliance during federal monitoring.
            </em>
        </p>
    </div>
</template>

<script>
// import { mapGetters, mapActions, mapState } from 'vuex';
// import { Log } from '$Shared/@arc/vue-arc';

export default {
    name: 'Section135Instructions',

    props: {
        asTooltip: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isTooltip: false,
            nextModule: { name: 'localApplication.CareerExplorationAndDevelopment' },
            previousModule: { name: 'localApplication.ProcessForAddressingDisparitiesAndGaps' },
        };
    },

    methods: {}
};
</script>

<style scoped>
h5 {
    font-weight: bold;
}
</style>
